module.exports = __webpack_public_path__ + "img/card-budget.6094943a.svg";